import { JetView } from "webix-jet";

export default class ToolbarView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		const padding = { left: 10, right: 10 };
		const state = this.getParam("state");

		const defbar = {
			view: "toolbar",
			padding,
			batch: "main",
			cols: [
				{
					view: "label",
					label: state.name,
				},
				{},
				{
					view: "icon",
					icon: "wxi-search",
					click: () => this.ShowSearchHeader(),
				},
			],
		};

		const searchbar = {
			view: "toolbar",
			padding,
			batch: "search",
			cols: [
				{ view: "text", localId: "search", placeholder: _("Search") },
				{
					view: "icon",
					icon: "wxi-close",
					click: () => this.HideSearchHeader(),
				},
			],
		};

		return {
			visibleBatch: "main",
			localId: "header",
			rows: [defbar, searchbar],
		};
	}

	/* initializes search properties and attaches event listening for search input*/
	init() {
		this.State = this.getParam("state", true);
		this.$$("search").attachEvent("onTimedKeyPress", () => {
			this.State.search = this.$$("search").getValue();
		});
	}

	/* shows search toolbar */
	ShowSearchHeader() {
		this.$$("header").showBatch("search");
		this.$$("search").focus();
	}

	/* hides search toolbar and reset filtering results in a table */
	HideSearchHeader() {
		this.$$("search").setValue("");
		this.$$("header").showBatch("main");
		this.State.search = "";
	}
}
